/* eslint-disable */
import { MODULE_NAME, } from '../constants';

export const SET_HEADERS = `${MODULE_NAME}/SET_HEADERS`;